import React from 'react';
import {markers} from '../../libs/config';

const Footer = ({mobView}) => {
  if (mobView) {
    return (
      <footer className="footer col-md-12" style={{padding: '5px', textAlign:'center'}}>
        <h5><a href="http://dhm.gov.np/contactus/" target="_blank" rel="noopener noreferrer">Contact Us</a></h5>
        <div>
          <a href="https://www.facebook.com/FlowForecasting/?hc_ref=SEARCH&fref=nf"><img className="icon" style={{height:'40px'}} src={markers.facebook} alt="not found"/></a>
          <a href="https://twitter.com/DHM_FloodEWS"><img className="icon" style={{height:'35px'}} src={markers.twitter} alt="not found"/></a>
        </div>
        <h4><img src="http://piwik.wscada.net/index.php?module=Counter&action=show&id=1" border="0" alt="not found"/></h4>
        <h5>POWERED BY WSCADA</h5>
        <h5><a href="https://www.rts.com.np" target="_blank">DESIGNED BY Real Time Solutions</a></h5>
        <h5>COPYRIGHT © 2017, HYDROLOGY DIVISION</h5>
      </footer>
    )
  } else {
    return (
      <footer className="footer col-md-12" style={{padding: '5px'}}>
        <div className="col-md-3 footer-lt">
          <div style={{height: '80%'}}>
            <h4><img src="http://piwik.wscada.net/index.php?module=Counter&action=show&id=1" border="0" alt="not found"/></h4>
          </div>
          <a href="https://www.rts.com.np" target="_blank" style={{color: 'white'}}>DESIGNED BY Real Time Solutions</a>
        </div>
        <div className="footer-mid col-md-6">
          <h5><a href="http://dhm.gov.np/contactus/" target="_blank" rel="noopener noreferrer">Contact Us</a></h5>
          <p>COPYRIGHT © 2018, HYDROLOGY DIVISION</p>
        </div>
        <div className="col-md-3 footer-rt">
          <div style={{height: '80%'}}>
            <a href="https://www.facebook.com/FlowForecasting/?hc_ref=SEARCH&fref=nf"><img className="icon" style={{height:'40px'}} src={markers.facebook} alt="not found"/></a>
            <a href="https://twitter.com/DHM_FloodEWS"><img className="icon" style={{height:'35px'}} src={markers.twitter} alt="not found"/></a>
          </div>
          <p style={{height: '20%'}}>POWERED BY WSCADA</p>
        </div>
      </footer>
    );
  }

};
export default Footer;


// WEBPACK FOOTER //
// ./src/components/common/Footer.js